/**
 * The panel vocabulary — ADR-015 §3: a CLOSED union, the same machine-check
 * idiom as SHELL_MODES and COMMAND_VERBS. A panel outside it cannot be laid
 * out, persisted, or mounted; each surface PR grows it by one entry. Pure
 * data — workspace.ts and the registry both depend on THIS, never on each
 * other (§4's boundary).
 * Depends on: nothing. Depended on by: workspace, panel-registry.
 */

export const PANEL_IDS = ['timeline', 'body', 'look', 'package'] as const;
export type PanelId = (typeof PANEL_IDS)[number];

export function isPanelId(raw: string): raw is PanelId {
  return (PANEL_IDS as readonly string[]).includes(raw);
}

/** The two registers of one tool (brief §1.1) — per-panel per ADR-015 Q3. */
export const REGISTERS = ['expert', 'creator'] as const;
export type Register = (typeof REGISTERS)[number];
